import React from "react"
import GlobalContextProvider from "./src/context/GlobalContextProvider"

require("prismjs/themes/prism-tomorrow.css")

export const wrapRootElement = ({ element }) => (
  <GlobalContextProvider>{element}</GlobalContextProvider>
)
